import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@vds/grids';
import ISPUModal from '../../../common/InstorePickup';
import { viewport, isShippingTabEnabled, isWHWPhase2Flag, isFuncComp } from '../../../common/Helpers';
import { getStoreHours, isIndirectStoresEnabled } from '../ShippingInfoHelper';

class ISPU extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      address: {
        zipCode: this.props.searchedInput ? this.props.searchedInput : '',
      },
    };
  }

  componentDidMount() {
    this.initiateISPU();
    const whwPlusCart = this.props?.cartDetails?.dueMonthlyList?.filter((obj) => obj.itemType === 'WHWPLUS');
    const whwGewhwPlusCart =
      this.props?.getCheckOutDetailsState?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
        obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
      );
    if (isWHWPhase2Flag() && isFuncComp() ? whwGewhwPlusCart?.length > 0 : whwPlusCart?.length > 0) {
      this.setState({ hasWHWPlusincart: true });
    }

    // if (isWHWPhase2Flag() && whwPlusCart?.length > 0) {
    //   this.setState({ hasWHWPlusincart: true });
    // }
  }

  initiateISPU = () => {
    if (this.props.zipCode) {
      const seatchInputTextBox = setInterval(() => {
        const inputElement =
          document.getElementsByName('ISPUInputField') &&
          document.getElementsByName('ISPUInputField').length > 0 &&
          document.getElementsByName('ISPUInputField')[0];
        if (inputElement) {
          inputElement.value = this.props.zipCode;
          clearInterval(seatchInputTextBox);
        }
      }, 5000);
    }
  };

  checkStores = (data) => {
    if (!data.zipCode) {
      return false;
    }
    const searchInputTextBox = setInterval(() => {
      const inputElement =
        document.getElementsByName('ISPUInputField') &&
        document.getElementsByName('ISPUInputField').length > 0 &&
        document.getElementsByName('ISPUInputField');
      if (inputElement) {
        inputElement.value = data.zipCode;
        clearInterval(searchInputTextBox);
      }
    }, 3000);
    const { excludeIndirect } = window.vzFlags || {};
    const postData = {
      data: {
        zipCode: data.zipCode,
        pageId: 'checkout',
        range: 15,
        showOnlyAvailableStores: true,
        excludeIndirect,
      },
    };
    if (this.state.address?.zipCode !== data?.zipCode) {
      this.setState({ address: { zipCode: data?.zipCode } });
      const pageLoad = false;
      this.props.getISPUStores(postData, pageLoad);
    }
    return true;
  };

  MaptoStoreObject = (data) => {
    let storeList = [];
    let filterData;

    if (data && data.length > 0) {
      if (isIndirectStoresEnabled()) {
        const dStore = data?.filter((i) => i.direct === 'Y')?.sort((a, b) => a.distance - b.distance);
        const iStore = data?.filter((i) => i.direct === 'N' && i.distance < 10)?.sort((a, b) => a.distance - b.distance); // instore mile filter for 10 miles
        filterData = [...dStore, ...iStore];
      } else {
        filterData = data;
      }
      storeList = filterData?.map((store) => {
        // If any item's quantity is 0 or less then it's not available
        const deviceAvailable = store?.items?.item && !store.items?.item.some((sku) => !sku.quantity || parseFloat(sku.quantity) <= 0);

        const availableServices = store?.storeAvailableServices?.toLowerCase() || '';
        const isInstorePickup = availableServices.includes('instore');
        const isCurbside = availableServices.includes('curbside');
        const isLimitedCurb = availableServices.includes('limitedcurb');
        let curbsidePickupMessage = isCurbside || isLimitedCurb ? 'Curbside Pickup hours:' : '';
        if (isLimitedCurb) {
          curbsidePickupMessage += getStoreHours(store, true);
        }

        const selectedProduct = store?.items?.item?.[0];
        const itemQuantity = selectedProduct?.quantity;
        return {
          curbsidePickupEligible: isCurbside,
          curbsidePickupMessage,
          limitedCurbsidePickupEligible: isLimitedCurb,
          ISPUPickupEligible: isInstorePickup,
          ISPUPickupMessage: isInstorePickup ? 'In-Store Pickup hours:' : '',
          storeName: store?.storeName,
          id: store.id,
          storeHeader: deviceAvailable ? 'Available Today' : 'Not Available at the store',
          orderMessage: deviceAvailable ? '' : 'In-Store Pickup is not available now',
          latitude: store?.location ? store?.location.latitude : '',
          longitude: store?.location ? store?.location.longitude : '',
          storeAddress: `${store?.address1}, ${store?.city}, ${store?.state}`,
          storeAddress1: `${store?.address1}`,
          storeAddress2: `${store?.city}, ${store?.state}`,
          deviceAvailable,
          phoneNumber: store?.phoneNumber,
          distance: store?.distance,
          netaceLocationCode: store?.netaceLocationCode,
          zipCode: store?.zipCode,
          storeHours: getStoreHours(store, false),
          direct: store?.direct,
          storeType:
            store?.direct === 'Y' && store?.businessName?.toLowerCase() === 'verizon wireless'
              ? 'Verizon Company Store'
              : 'Verizon Authorized Retailer',
          itemQuantity,
        };
      });
    }
    return storeList;
  };

  toggleModal = () => {
    this.setState((prevState) => {
      this.props.updateFromISPU(prevState.address.zipCode !== '');
      return {
        showModal: !prevState.showModal,
      };
    });
  };

  updateFromISPU = (isUpdated) => {
    if (!isUpdated) {
      this.setState((prevState) => ({
        selectedShippingCode: prevState.selectedShippingCode,
      }));
    }
  };

  // getStoreDetails = (selectedStore) => {
  //   // if (selectedStore) {
  //   //   const selectedStoreValue = selectedStore;
  //   // }
  // };

  submitISPU = (store) => {
    const searchedInput =
      document.getElementsByName('ISPUInputField') &&
      document.getElementsByName('ISPUInputField').length > 0 &&
      document.getElementsByName('ISPUInputField')[0].value;
    if (this.state.hasWHWPlusincart) {
      this.props.getStoreDetails(store);
    } else {
      this.setState(
        {
          showModal: false,
          address: {
            zipCode: searchedInput,
          },
        },
        () => {
          this.props.updateISPUShippingOption({
            homePhoneAdded: this.props.homePhoneAdded,
            locationCode: store ? store.netaceLocationCode : '',
            purchasePath: this.props.purchasePath,
            lineLevelShipment: this.props.lineLevelShipment,
            lineLevelShipmentSelectedLineSequenceNumber: this.props.lineLevelShipmentSelectedLineSequenceNumber,
            selectedOption: this.props.selectedOption,
            storeInfo: {
              storeName: store && store.storeName,
              storeAddress: store && store.storeAddress,
              zipcode: store && store.zipCode,
              distance: store && store.distance,
              id: store && store.id,
            },
            isSelectedFromISPUModal: isShippingTabEnabled(),
            cradleResponseDetails: this.props.cradleResponseDetails,
          });
        },
        this.toggleModal(),
      );
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(`ISPU${nextProps}`);
    const inputElement =
      document.getElementsByName('ISPUInputField') &&
      document.getElementsByName('ISPUInputField').length > 0 &&
      document.getElementsByName('ISPUInputField')[0];
    if (inputElement) {
      inputElement.value = this.state.zipCode;
    }
  }

  render() {
    const type = viewport();

    const inventoryCheckInfo = {
      title:
        'Sorry, there are no store near you that are available for in-store pickup. Select one of our shipping methods and let us ship it to you.',
    };

    const ispuModalClass = type === 'mobile' ? 'pad18 onlyTopPad ispuModalBodyMarginTop' : 'pad18 onlyTopPad';
    const newISPUProps = { address: { zipcode: this.state.address?.zipCode ? this.state.address?.zipCode : this.props.zipCode } };
    const storeList = this.MaptoStoreObject(this.props.storeLists);

    return (
      this.state.showModal && (
        <section id="ispu_cc" className={ispuModalClass}>
          <Row>
            <Col xs={12}>
              <ISPUModal
                chooseStoreText="Choose a store to pick up your order."
                checkStores={this.checkStores}
                storeList={storeList}
                showModal={this.state.showModal}
                submitISPU={this.submitISPU}
                toggleModal={() => this.toggleModal()}
                inventoryCheckInfo={this.props.showIspuStoreError && inventoryCheckInfo}
                {...newISPUProps}
              />
            </Col>
          </Row>
        </section>
      )
    );
  }
}

ISPU.propTypes = {
  storeLists: PropTypes.array,
  showIspuStoreError: PropTypes.bool,
  getISPUStores: PropTypes.func,
  updateFromISPU: PropTypes.func,
  searchedInput: PropTypes.string,
  selectedOption: PropTypes.object,
  updateISPUShippingOption: PropTypes.func,
  lineLevelShipment: PropTypes.bool,
  lineLevelShipmentSelectedLineSequenceNumber: PropTypes.string,
  purchasePath: PropTypes.string,
  zipCode: PropTypes.string,
  cartDetails: PropTypes.object,
  postAddToCart: PropTypes.func,
  removedWHWPlus: PropTypes.bool,
  ispuStoreInfo: PropTypes.object,
  getStoreDetails: PropTypes.func,
  homePhoneAdded: PropTypes.bool,
  cradleResponseDetails: PropTypes.object,
  getCheckOutDetailsState: PropTypes.object,
};

export default ISPU;
